"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback, useMemo } from "react";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { DropSize } from "@/helpers/waves/drop.helpers";
import { useDrop } from "@/hooks/useDrop";
import { useWaveData } from "@/hooks/useWaveData";
export const useSingleWaveDropData = (initialDrop, onClose) => {
  const $ = _c(15);
  let t0;
  if ($[0] !== initialDrop.id) {
    t0 = {
      dropId: initialDrop.id
    };
    $[0] = initialDrop.id;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    drop
  } = useDrop(t0);
  let t1;
  if ($[2] !== onClose) {
    t1 = () => {
      onClose();
    };
    $[2] = onClose;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const onWaveNotFound = t1;
  const t2 = drop?.wave.id ?? null;
  let t3;
  if ($[4] !== onWaveNotFound || $[5] !== t2) {
    t3 = {
      waveId: t2,
      onWaveNotFound
    };
    $[4] = onWaveNotFound;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const {
    data: wave
  } = useWaveData(t3);
  let t4;
  if ($[7] !== drop || $[8] !== initialDrop.stableHash || $[9] !== initialDrop.stableKey) {
    t4 = drop ? {
      type: DropSize.FULL as const,
      ...drop,
      stableHash: initialDrop.stableHash,
      stableKey: initialDrop.stableKey
    } : null;
    $[7] = drop;
    $[8] = initialDrop.stableHash;
    $[9] = initialDrop.stableKey;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const extendedDrop = t4;
  let t5;
  if ($[11] !== drop || $[12] !== extendedDrop || $[13] !== wave) {
    t5 = {
      drop,
      wave,
      extendedDrop
    };
    $[11] = drop;
    $[12] = extendedDrop;
    $[13] = wave;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
};